<template>
	<div class="min-w-10">
		<BaseButton
			color="secondary"
			size="md"
			:square="!search"
			class="snap-start"
			@click="openSearch()"
		>
			<SearchIcon class="h-5 w-5" />
			<div class="max-w-20 min-w-0 truncate" v-if="search">{{ search }}</div>
			<CloseIcon
				class="text-label-tertiary h-5 w-5 after:absolute after:-inset-3"
				@click="clear"
				@touchstart.stop
				v-if="search"
			/>
		</BaseButton>
		<SearchModal v-model:show="show" v-model:search="search" />
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SearchModal from './modals/SearchModal.vue'
import SearchIcon from '@/assets/icons/search.svg'
import BaseButton from './BaseButton.vue'
import CloseIcon from '@/assets/icons/close.svg'

const show = ref(false)

const search = defineModel<string>()

const openSearch = () => {
	show.value = true
}

const clear = (e: Event) => {
	e.stopPropagation()
	e.stopImmediatePropagation()
	search.value = ''
}
</script>
